import { render, staticRenderFns } from "./add-weight-measurement.vue?vue&type=template&id=e7cfb4a8&"
import script from "./add-weight-measurement.vue?vue&type=script&lang=js&"
export * from "./add-weight-measurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports